import { IconMinusBold, IconPlusBold, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface ItemCardCounterProps {
  count: number;
  disable_min_disabled?: boolean;
  disable_max_disabled?: boolean;
  handleIncrease: () => void;
  handleDecrease: () => void;
}

export const ItemCardCounter = ({
  count,
  disable_min_disabled = false,
  disable_max_disabled = false,
  handleIncrease,
  handleDecrease,
}: ItemCardCounterProps) => {
  return (
    <CounterContainer>
      <IconMinusBold
        size={20}
        v3Color={disable_min_disabled ? 'gray400' : 'gray950'}
        onClick={handleDecrease}
        cursor={disable_min_disabled ? 'auto' : 'pointer'}
      />

      <CountDisplay>
        <Text variant='Body_16_Regular' v3Color='gray900'>
          {count}
        </Text>
      </CountDisplay>

      <IconPlusBold
        size={20}
        v3Color={disable_max_disabled ? 'gray400' : 'gray950'}
        onClick={handleIncrease}
        cursor={disable_max_disabled ? 'auto' : 'pointer'}
      />
    </CounterContainer>
  );
};

const CounterContainer = styled.div`
  display: inline-flex;
  align-items: center;
  min-width: 96px;
  height: 32px;
`;

const CountDisplay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  height: 32px;
  margin: 0 4px;
  border-radius: 8px;
  border: 1px solid ${vars.v3Color.gray150};
  background-color: ${vars.v3Color.white};

  &::before {
    content: '';
    height: 100%;
  }
`;
